var products_on_page = $('#product-grid');
var next_url = products_on_page.data('next-url');

var btn_loader = $('.load-product');
var prog_load = $('.product-bar');

function loadMoreProducts () {
  // Prevent multiple simultaneous loads
  if (window.loadingMoreProducts) {
    return;
  }
  window.loadingMoreProducts = true;

  $.ajax(
    {
        url: next_url,
        type:'GET',
        dataType:'html',
        beforeSend: function(){
          btn_loader.hide();
          prog_load.show();
        }
    }
  ).done(function(next_page) {
    prog_load.hide();
    var new_products = $(next_page).find('#product-grid');
    var new_url = new_products.data('next-url');

    if(new_url)
      btn_loader.show();

    next_url = new_url;

    // Only append the product cards (children), not the container itself
    // This prevents duplicate containers and overflow issues
    var productCards = new_products.children();
    
    if (productCards.length > 0) {
      // Append all products at once to prevent layout shifts
      products_on_page.append(productCards);
      
      // Initialize swatches after products are appended
      setTimeout(function() {
        initSwatches();
        // Reinitialize swatch overflow indicators if function exists
        if (typeof initSwatchOverflowIndicators === 'function') {
          setTimeout(initSwatchOverflowIndicators, 100);
        }
        window.loadingMoreProducts = false;
      }, 50);
    } else {
      window.loadingMoreProducts = false;
    }
  }).fail(function() {
    prog_load.hide();
    btn_loader.show();
    window.loadingMoreProducts = false;
  });

  // console.log(loadMoreProducts);
}


// Get the modal
var modal = document.getElementById("myModal");

// Get the button that opens the modal
var btn = document.getElementById("myBtn");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];

// When the user clicks the button, open the modal 
if (btn && modal) {
  btn.onclick = function() {
    modal.style.display = "block";
  }
}

// When the user clicks on <span> (x), close the modal
if (span && modal) {
  span.onclick = function() {
    modal.style.display = "none";
  }
}

// When the user clicks anywhere outside of the modal, close it
if (modal) {
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  }
}